import { resources } from "./i18n-resources/index";
import { initialize, getCulture } from "./utils/LocalizationHelpers";

initialize([resources], getCulture());
